var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8284 6.82843C12.3905 5.26633 12.3905 2.73367 10.8284 1.17157C9.26633 -0.390524 6.73366 -0.390524 5.17157 1.17157C3.60947 2.73367 3.60947 5.26633 5.17157 6.82843C6.73366 8.39052 9.26633 8.39052 10.8284 6.82843ZM1 15.65C1.00447 11.9791 4.13587 9.00424 8.00001 9L8.00009 9C11.8642 9.00429 14.9956 11.9791 15 15.6501C15 15.8433 14.8351 16 14.6316 16H1.36842C1.16495 16 1 15.8433 1 15.65Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8284 6.82843C12.3905 5.26633 12.3905 2.73367 10.8284 1.17157C9.26633 -0.390524 6.73366 -0.390524 5.17157 1.17157C3.60947 2.73367 3.60947 5.26633 5.17157 6.82843C6.73366 8.39052 9.26633 8.39052 10.8284 6.82843ZM1 15.65C1.00447 11.9791 4.13587 9.00424 8.00001 9L8.00009 9C11.8642 9.00429 14.9956 11.9791 15 15.6501C15 15.8433 14.8351 16 14.6316 16H1.36842C1.16495 16 1 15.8433 1 15.65Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.5e463bf41b54537d441fbfc5b59d6a74.svg";
export { ForwardRef as ReactComponent };